import React, { useState } from "react";
import {
  Menu,
  X,
  Search,
  Bell,
  User,
  ChevronDown,
  ChevronRight,
} from "lucide-react";
import { Container } from "@mui/material";
import { Link } from "react-router-dom";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [mobileSubMenuOpen, setMobileSubMenuOpen] = useState({});

  const toggleMobileSubMenu = (index) => {
    setMobileSubMenuOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "Latest Job", path: "#" },
    { label: "Admit Card", path: "#" },
    { label: "Result", path: "#" },
    { label: "Admission", path: "#" },
    { label: "Syllabus", path: "#" },
    { label: "Answer Key", path: "#" },
    { label: "More", path: "#" },
    { label: "Contact Us", path: "#" },
    {
      label: "Privacy Policy",
      subItems: [
        { label: "Wallpaper App", path: "/wallpaper/privacyPolicy" },
        { label: "Shayari App", path: "/shayari/privacyPolicy" },
        { label: "GK App", path: "/gk/privacyPolicy" },
        { label: "NCERT Solutions", path: "/ncert/privacyPolicy" },
        { label: "Chemistry App", path: "/chemistry/privacyPolicy" },
        { label: "Mathematics App", path: "/mathematics/privacyPolicy" },
        { label: "Document Scanner", path: "/documentScanner/privacyPolicy" },
        { label: "Delete Account", path: "/shayari/deleteAccount" },
      ],
    },
    { label: "Disclaimer", path: "#" },
  ];

  return (
    <header className="relative z-50 w-full bg-[#05055F] text-white shadow-md">
      {/* Logo */}
      <Container maxWidth="xl">
        <div className="flex items-center justify-start pt-2">
          <div>
            <h1 className="mb-2 text-3xl font-bold tracking-wide">
              Sarkari Result <span className="text-yellow-300">Setu</span>
            </h1>
            <span className="rounded bg-yellow-400 px-2 py-0.5 text-xl font-normal text-black">
              SarkariResultSetu.com
            </span>
          </div>
        </div>

        <div className="mx-auto flex items-center justify-between py-3">
          {/* Desktop Menu */}
          <nav className="hidden items-center space-x-4 text-sm font-semibold md:flex lg:space-x-6">
            {menuItems.map((item, index) => (
              <div key={index} className="group relative">
                {item.subItems ? (
                  <button className="flex items-center gap-1 transition hover:text-yellow-300 focus:outline-none">
                    {item.label}
                    <ChevronDown size={14} />
                  </button>
                ) : (
                  <Link
                    to={item.path}
                    className="transition hover:text-yellow-300"
                  >
                    {item.label}
                  </Link>
                )}

                {/* Dropdown Menu */}
                {item.subItems && (
                  <div className="absolute left-0 top-full hidden w-56 pt-2 group-hover:block">
                    <div className="rounded-md bg-white py-2 shadow-lg ring-1 ring-black ring-opacity-5">
                      {item.subItems.map((subItem, subIndex) => (
                        <Link
                          key={subIndex}
                          to={subItem.path}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600"
                        >
                          {subItem.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* Icons */}
          <div className="hidden items-center space-x-5 text-white md:flex">
            <Search className="cursor-pointer hover:text-yellow-300" />
            <Bell className="cursor-pointer hover:text-yellow-300" />
            <User className="cursor-pointer hover:text-yellow-300" />
          </div>

          {/* Mobile Menu Button */}
          <button
            className="text-white md:hidden"
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Dropdown */}
        {open && (
          <div className="space-y-3 rounded-b-lg bg-red-700 px-4 py-4 text-white md:hidden">
            {menuItems.map((item, index) => (
              <div key={index}>
                {item.subItems ? (
                  <div>
                    <button
                      onClick={() => toggleMobileSubMenu(index)}
                      className="flex w-full items-center justify-between border-b border-red-500 py-2 text-left hover:text-yellow-300"
                    >
                      {item.label}
                      {mobileSubMenuOpen[index] ? (
                        <ChevronDown size={16} />
                      ) : (
                        <ChevronRight size={16} />
                      )}
                    </button>
                    {mobileSubMenuOpen[index] && (
                      <div className="ml-4 space-y-2 py-2">
                        {item.subItems.map((subItem, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subItem.path}
                            className="block py-1 text-sm text-gray-200 hover:text-yellow-300"
                            onClick={() => setOpen(false)}
                          >
                            {subItem.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    className="block w-full border-b border-red-500 py-2 text-left hover:text-yellow-300"
                    onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}

            {/* Icons for Mobile */}
            <div className="flex items-center space-x-5 pt-3">
              <Search className="cursor-pointer hover:text-yellow-300" />
              <Bell className="cursor-pointer hover:text-yellow-300" />
              <User className="cursor-pointer hover:text-yellow-300" />
            </div>
          </div>
        )}
      </Container>
    </header>
  );
}
